/**
 * @jsxRuntime classic
 */
/** @jsx jsx */
import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { N0, N800 } from '@atlaskit/theme/colors';
import TooltipPrimitive from './TooltipPrimitive';
var baseStyles = css({
  boxSizing: 'border-box',
  maxWidth: '240px',
  padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
  insetBlockStart: "var(--ds-space-0, 0px)",
  insetInlineStart: "var(--ds-space-0, 0px)",
  borderRadius: "var(--ds-border-radius, 3px)",
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  backgroundColor: "var(--ds-background-neutral-bold, ".concat(N800, ")"),
  color: "var(--ds-text-inverse, ".concat(N0, ")")
});
var truncateStyles = css({
  maxWidth: '420px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
var TooltipContainer = /*#__PURE__*/forwardRef(function TooltipContainer(_ref, ref) {
  var style = _ref.style,
    className = _ref.className,
    children = _ref.children,
    truncate = _ref.truncate,
    placement = _ref.placement,
    testId = _ref.testId,
    onMouseOut = _ref.onMouseOut,
    onMouseOver = _ref.onMouseOver,
    id = _ref.id;
  return jsx(TooltipPrimitive, {
    ref: ref
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className,
    placement: placement,
    testId: testId,
    id: id,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver,
    css: [baseStyles, truncate ? truncateStyles : null]
  }, children);
});
TooltipContainer.displayName = 'TooltipContainer';
export default TooltipContainer;